import { Component } from '@angular/core';
import { Platform, NavController, NavParams, ToastController } from 'ionic-angular';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';

import { ConsumerMoneyDeviceProvider } from '../../providers/consumer-money-device';
import { BaseManagement } from '../../providers/base-management';


@Component({
  selector: 'page-consumer-money-add-device',
  templateUrl: 'consumer-money-add-device.html',
})
export class ConsumerMoneyAddDevicePage extends BaseManagement {
	deviceToAdd: any = "";
	business: any;
	options: BarcodeScannerOptions;

	platformReadySource: any;

	constructor(
		public platform: Platform, 
		private barcodeScanner: BarcodeScanner,
		public toastCtrl: ToastController,
		public consumerMoneyDeviceProvider: ConsumerMoneyDeviceProvider,
		public navCtrl: NavController, 
		public navParams: NavParams) {
		super();

		platform.ready().then((readySource) => {
			this.platformReadySource = readySource;
		})

		this.business = this.navParams.get('business')
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerMoneyAddDevicePage');
	}

	async scan(){
		if(this.platformReadySource=="dom" || this.isWorking()) return;

	    this.startWorking("scan")

	    this.options = {
	      prompt: 'Scan the code printed on the device'
	    }

	    this.barcodeScanner.scan().then(results => {
		    try{
		      console.log(results);

		      if(results.cancelled == true){
		        this.stopWorking()
		        return;
		      }

		      this.deviceToAdd = results.text;

		      this.stopWorking()   
		    }catch(e){
		      this.stopWorking()
		    }	    	
	    });
	}

	deviceIsValid(){
		var isvalid = true;

		if(this.deviceToAdd.length<3){
			isvalid = false;
		}

		return isvalid;
	}

	addDevice(){
		if(this.isWorking()){
			return;
		}

		this.startWorking("addingDevice")

		this.consumerMoneyDeviceProvider.addDevice({
		    device: this.deviceToAdd,    	
		    businessId: this.business.Id
		})
		.then((data: any)=>{
			this.stopWorking()

			if(data.Message){
				let toast = this.toastCtrl.create({
					message: 'There was an error: ' + data.Message,
					duration: 5000,
					position: 'bottom'
				});

				toast.present();  
			}else{
				this.consumerMoneyDeviceProvider.getDevices({businessId: this.business.Id});

				let toast = this.toastCtrl.create({
					message: 'Device added successfully!',
					duration: 5000,
					position: 'middle',
					showCloseButton: true,
					closeButtonText: 'Ok'
				});

				toast.onDidDismiss(() => {
					this.navCtrl.pop();
				});

				toast.present();  
			}
		})
		.catch((err)=>{
			this.stopWorking()

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

		  	toast.present();  
		});							
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-money-add-device/consumer-money-add-device.ts